import React from 'react';

import { Title } from './style';

function Warning({ area, text }) {
  return text ? <Title area={area}>{text}</Title> : null;
}

export default Warning;
